/**
 * Hosts that serve only the public landing page: no sign-in and none of the
 * app. Every other host (demo/UAT, local dev, previews) serves the full app.
 *
 *   REACT_APP_LANDING_HOSTS=myhomevault.com.au,www.myhomevault.com.au
 *
 * Read at runtime against window.location, so one build serves both.
 */
export const landingHosts = (process.env.REACT_APP_LANDING_HOSTS || '')
  .split(',')
  .map((host) => host.trim().toLowerCase())
  .filter(Boolean)

export const isLandingHost = (hostname = window.location.hostname) =>
  landingHosts.includes(hostname.toLowerCase())
